export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ15.64fab0b2.mp3";